import { Button, Flex, Image, Link, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import SidebarHelpImage from "assets/img/sign.jpg";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useContext } from "react";
import { auth } from "lib/firebase";
import { useHistory } from "react-router-dom";

export default function SidebarDocs({ landing }) {
  const textColor = useColorModeValue("gray.700", "white");
  const history = useHistory();

  const { sidebarWidth } = useContext(SidebarContext);

  const signOut = async () => {
    try {
      await auth.signOut();
      console.log("User signed out!");
      history.push("/");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <Flex
      justify="center"
      direction="column"
      align="center"
      display={sidebarWidth !== 275 && "none"}
    >
      <Image src={SidebarHelpImage} w="165px" ms="24px" />
      <Flex direction="column" align="center" textAlign="center" mb="12px" me="24px">
        <Text fontSize="14px" color={landing ? "white" : textColor} fontWeight="bold">
          Need help?
        </Text>
        <Link
          href="mailto:vishu15singh@gmail.com"
          color={landing ? "white" : "gray.500"}
          fontSize="12px"
        >
          vishu15singh@gmail.com
        </Link>
      </Flex>
      <Link href="#">
        <Button
          variant={landing ? "light" : "primary"}
          bgColor="green.500"
          mb={{ sm: "12px", xl: "16px" }}
          color={landing && "blue.500"}
          _hover={{ bgColor: "gray.300", color: "black" }}
          fontWeight="bold"
          minW="185px"
          ms="24px"
          fontSize="sm"
          onClick={signOut}
        >
          Sign Out
        </Button>
      </Link>
    </Flex>
  );
}
